import React, { useEffect, useState } from "react"
import "antd/dist/antd.less"
// import "antd/dist"
import "./styles/main.less"
import "react-toastify/dist/ReactToastify.css"
import AppLayout from "./containers/layout"
import { AuthProvider } from "./contexts/auth/AuthContext"
import { ConfigProvider } from "antd"
import moment from "moment"
import ru_RU from "antd/lib/locale/ru_RU"
import en_US from "antd/lib/locale/en_US"
import "moment/locale/ru"
import "./styles/Dark.css"
import i18n from "./services/i18n"
import { ConfigProviderProps } from "antd/lib/config-provider"
import { ToastContainer } from "react-toastify"
import { ThemeProvider } from "./contexts/ThemeContex"
import { SocketProvider } from "./contexts/SocketContext"
import ErrorBoundary from "./components/ErrorBoundary"
import NewVersionBanner from "./components/NewVersionBanner"   // tog'a #2389: ochiq tab eski versiyada qolib ketmasin
import CallManager from "./components/chat/CallManager"   // Tog'a #342: WebRTC qo'ng'iroq
import "./styles/sav-theme.less"   // SAV dizayni (2026-10-18): tokenlar + umumiy qatlam — layout CSS'idan KEYIN ulanadi
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// import moment from "moment";

const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: `'${i18n.t("requiredField")} - \${label}'`,
}

moment.locale("ru")

// notification.config({
//   placement: "bottomRight",
//   duration: 3,
// });

// Msg 436 (tarjima): antd ichki matnlari ("Нет данных" kabi) tanlangan tilga
// ergashadi. UZ uchun antd'da rasmiy paket yo'q — komponent matnlari i18n'dan
// olinadi, antd bazasi esa EN'da qoladi (ru emas — aralashmasin).
const appLang = (() => {
  try {
    const v = localStorage.getItem("app_lang")
    return v === "uz" || v === "en" || v === "ru" ? v : "ru"
  } catch {
    return "ru"
  }
})()

const antdConfig: ConfigProviderProps = {
  locale: appLang === "ru" ? ru_RU : en_US,
  form: { validateMessages },
}

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider {...antdConfig}>
        <SocketProvider>
          <AuthProvider>
            <ThemeProvider>
              <AppLayout />
              <ToastContainer position="bottom-right" />
              <NewVersionBanner />
              <CallManager />{/* Tog'a #342 (katalog #6024): chat → «📞 Позвонить через интернет» (bitta global nusxa) */}
            </ThemeProvider>
          </AuthProvider>
        </SocketProvider>
        {/* <ReactQueryDevtools  /> */}
      </ConfigProvider>
    </ErrorBoundary>
  )
}

export default App
